import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Loader2, Calendar, Plus } from "lucide-react";

export default function PortalAppointments() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    http.get("/portal/appointments").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="portal-appointments">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-4xl">My Appointments</h1>
          <p className="mt-2 text-navy/65">Discovery calls, service meetings, and signing sessions.</p>
        </div>
        <Link to="/book" data-testid="appts-book-cta" className="btn-primary"><Plus className="w-4 h-4" /> New Appointment</Link>
      </div>
      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center">
            <Calendar className="w-10 h-10 text-gold mx-auto" />
            <h3 className="mt-3 text-2xl">Nothing scheduled.</h3>
            <p className="mt-2 text-navy/65">Use the booking page to set up your first appointment.</p>
            <Link to="/book" className="btn-primary mt-6 inline-flex">Book Appointment</Link>
          </div>
        ) : (
          <ul className="card divide-y divide-navy/5">
            {items.map((a, i) => (
              <li key={a.appointment_id} className="p-5 flex items-center justify-between" data-testid={`appt-${i}`}>
                <div>
                  <div className="text-navy font-medium">{a.title}</div>
                  <div className="text-xs text-navy/55">{a.starts_at}</div>
                  {a.notes && <div className="text-sm text-navy/70 mt-1">{a.notes}</div>}
                </div>
                <span className="text-xs uppercase tracking-widest text-gold">{a.status}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
